const MEDIA_ITEMS = [
  {
    tag: '精彩预告',
    title: '《长安风云录》第二季先导预告',
    dur: '02:35',
    desc: '古装权谋巨制回归，服化道全面升级，剧情更加扣人心弦。天美影视高清同步上线。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20historical%20drama%20cinematic%20visual%20with%20warm%20golden%20lighting%2C%20classical%20palace%20atmosphere%2C%20refined%20texture%2C%20dramatic%20composition%2C%20no%20text%20no%20people%2C%20clean%20artistic%20composition&width=800&height=450&seq=media-01&orientation=landscape',
    alt: '天美影视长安风云录第二季预告',
  },
  {
    tag: '花絮特辑',
    title: '《极限追击》幕后拍摄揭秘',
    dur: '05:18',
    desc: '揭秘动作大片拍摄现场，实景爆破与惊险特技全记录，见证硬核动作电影的诞生。',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20behind-the-scenes%20cinematic%20visual%20with%20dramatic%20red%20and%20amber%20lighting%2C%20intense%20production%20atmosphere%2C%20film%20set%20energy%2C%20no%20text%20no%20people%2C%20clean%20artistic%20composition&width=800&height=450&seq=media-02&orientation=landscape',
    alt: '天美影视极限追击幕后花絮',
  },
  {
    tag: '独家专访',
    title: '年度十佳影视作品主创对话',
    dur: '12:40',
    desc: '对话年度口碑佳作导演与编剧，深度解读创作背后故事，了解高分影视作品的诞生过程。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20interview%20cinematic%20visual%20with%20warm%20golden%20studio%20lighting%2C%20elegant%20film%20industry%20atmosphere%2C%20refined%20composition%2C%20no%20text%20no%20people%2C%20clean%20artistic%20composition&width=800&height=450&seq=media-03&orientation=landscape',
    alt: '天美影视年度佳作主创专访',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">精彩视频</h2>
          <p className="mt-2 text-sm text-foreground-600">预告片、花絮与独家专访，感受影视幕后魅力</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {MEDIA_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-video overflow-hidden relative">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-background-950/20 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2.5 py-1 bg-background-950/70 rounded-md text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.dur}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2.5 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="font-heading text-base text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}